<template>
  <slot
    name="activator"
    :show="() => modalManager.showModal(id)"
    @click.capture.prevent=""
  />
  <teleport to="#modal">
    <div
      v-if="modalManager.isModalVisible(id)"
      style="z-index: 999999999"
      class="w-screen h-screen bg-black/50 fixed top-0 left-0 flex flex-wrap"
      @click="dismissible && hide()"
    >
      <div
        class="container m-auto bg-white rounded-2xl shadow-xl max-w-max max-h-screen"
        @click.stop=""
      >
        <slot name="content" :hide="() => hide()" />
      </div>
    </div>
  </teleport>
</template>
<script lang="ts" setup>
import useModalManager from './modal-manager'
import { v4 as uuid4 } from 'uuid'
import { onBeforeUnmount, onMounted } from 'vue'

const id = uuid4()
const modalManager = useModalManager()
modalManager.addModal(id)

const props = withDefaults(defineProps<{ dismissible?: boolean }>(), {
  dismissible: false,
})

const emit = defineEmits<(e: 'hide') => void>()

function hide() {
  modalManager.hideModal(id)
  emit('hide')
}

function dismissOnEsc(event: KeyboardEvent) {
  if (event.key === 'Escape' && props.dismissible) {
    hide()
  }
}
onMounted(() => {
  document.addEventListener('keydown', dismissOnEsc)
})

onBeforeUnmount(() => document.removeEventListener('keydown', dismissOnEsc))

defineExpose({
  hide: () => hide(),
  show: () => modalManager.showModal(id),
})
</script>
